export default __webpack_public_path__ + "static/media/pic81.73b95465.jpg";